import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/index.vue';

Vue.use(Router);
const menuRoute = [
  {
    path: '/cloud-manage',
    component: Layout,
    name: '云管家平台',
    hidden: false,
    meta: { icon: 'flow-new', activeIcon: 'flow-new-x', title: '云管家平台' },
    children: [
      {
        path: 'split-account',
        name: 'split-account',
        component: () => import('@/views/cloud-manage/split-account'),
        meta: { title: '云管家分账', icon: 'icon2' },
        hidden: false,
        children: [
          {
            path: 'open',
            name: 'open',
            component: () => import('@/views/cloud-manage/split-account/open'),
            meta: { title: '我的云管家', icon: 'icon2' },
          },
          {
            path: 'receiver',
            name: 'receiver',
            component: () => import('@/views/cloud-manage/split-account/receiver'),
            meta: { title: '接收方管理', icon: 'icon2' },
          },
          {
            path: 'divide-accounts',
            name: 'divide-accounts',
            component: () => import('@/views/cloud-manage/split-account/divide-accounts'),
            meta: { title: '分账记录', icon: 'icon2' },
          },
          {
            path: 'withdrawal-records',
            name: 'withdrawal-records',
            component: () => import('@/views/cloud-manage/split-account/withdrawal-records'),
            meta: { title: '提现记录', icon: 'icon2' },
          },
        ],
      },
      {
        path: 'enterprise-same-name-transfer',
        name: 'enterprise-same-name-transfer',
        component: () => import('@/views/cloud-manage/enterprise-same-name-transfer'),
        meta: { title: '企业同名转账', icon: 'icon2' },
        hidden: false,
        children: [
          {
            path: 'recharge-record',
            name: 'recharge-record',
            component: () => import('@/views/cloud-manage/enterprise-same-name-transfer/recharge-record'),
            meta: { title: '充值记录', icon: 'icon2' },
          },
          {
            path: 'payment-record',
            name: 'payment-record',
            component: () => import('@/views/cloud-manage/enterprise-same-name-transfer/payment-record'),
            meta: { title: '代付记录', icon: 'icon2' },
          },
        ],
      },
    ],
  },
  {
    path: '/flow-new',
    component: Layout,
    name: '实时交易',
    hidden: true,
    meta: { icon: 'flow-new', activeIcon: 'flow-new-x' },
    children: [
      {
        path: 'index',
        name: 'flow-new',
        component: () => import('@/views/flow/index-new'),
        meta: { title: '实时交易', icon: 'icon2' },
      },
    ],
  },
  {
    path: '/expense-details',
    component: Layout,
    name: '费用明细',
    hidden: true,
    meta: { icon: 'expense-details', activeIcon: 'expense-details-x' },
    children: [
      {
        path: 'index',
        name: 'expense-details',
        component: () => import('@/views/expense-details/index'),
        meta: { title: '费用明细', icon: 'icon2' },
      },
    ],
  },
  {
    path: '/payment-manage',
    component: Layout,
    name: '打款管理',
    hidden: false,
    meta: { icon: 'payment', activeIcon: 'payment-x', title: '打款管理' },
    children: [
      {
        path: 'records',
        name: 'payment-records',
        component: () => import('@/views/payment-manage/payment-records'),
        meta: { title: '打款记录', icon: 'icon2' },
      },
      {
        path: 'settlement-receipt',
        name: 'settlement-receipt',
        component: () => import('@/views/payment-manage/settlement-receipt'),
        meta: { title: '结算回执单管理', icon: 'icon2' },
      },
    ],
  },
  // 对账单导出图标已在文件夹中 export export-x
  {
    path: '/bill-export',
    component: Layout,
    name: '对账单导出',
    hidden: true,
    meta: { icon: 'export', activeIcon: 'export-x' },
    children: [
      {
        path: 'index',
        name: 'bill-export',
        component: () => import('@/views/bill-export/index'),
        meta: { title: '对账单导出', icon: 'export' },
      },
    ],
  },
  // 提现记录图标已在文件夹中 withdraw-record withdraw-record-x
  {
    path: '/collection-bill',
    component: Layout,
    name: '收款单',
    hidden: true,
    meta: { icon: 'icon8', activeIcon: 'icon8-x' },
    children: [
      {
        path: 'index',
        name: 'collection-bill-index',
        component: () => import('@/views/collection-bill/index'),
        meta: { title: '收款单', icon: 'iconcebianlanicon-2' },
      },
      {
        path: 'detail',
        name: 'collection-bill-detail',
        component: () => import('@/views/collection-bill/detail'),
        meta: { title: '收款单详情', icon: 'iconcebianlanicon-2' },
        hidden: true,
      },
      {
        path: 'create',
        name: 'collection-bill-create',
        component: () => import('@/views/collection-bill/create.vue'),
        meta: { title: '创建收款单', icon: 'iconcebianlanicon-2' },
        hidden: true,
      },
    ],
  },
  {
    path: '/deposit-order',
    component: Layout,
    name: '预付通',
    hidden: true,
    meta: { icon: 'icon10', activeIcon: 'icon10-x' },
    children: [
      {
        path: 'index',
        name: 'advance-payment-index',
        component: () => import('@/views/advance-payment/index'),
        meta: { title: '预付通', icon: 'iconcebianlanicon-2' },
      },
    ],
  },
  {
    path: '/merchant-info',
    component: Layout,
    name: '商户信息',
    meta: { icon: 'icon7', activeIcon: 'icon7-x' },
    children: [
      {
        path: 'detail',
        name: 'merchant-info',
        component: () => import('@/views/merchant-info/index'),
        meta: { title: '门店管理', icon: 'icon7' },
      },
      {
        path: 'modifyInfo',
        name: 'view-info',
        component: () => import('@/views/merchant-info/view-info'),
        meta: {
          title: '商户基本信息', icon: 'iconcebianlanicon-4', activeMenu: '/merchant-info/detail',
        },
        hidden: true,
      },
    ],
  },
  {
    path: '/device-manage',
    component: Layout,
    name: '设备管理',
    meta: { icon: 'icon5', activeIcon: 'icon5-x' },
    children: [
      {
        path: 'detail',
        name: 'device-manage',
        component: () => import('@/views/device-manage/index'),
        meta: { title: '设备管理', icon: 'icon5' },
      },
    ],
  },
  {
    path: '/member-permisson',
    component: Layout,
    name: '成员与权限',
    meta: { title: '成员与权限', icon: 'icon6', activeIcon: 'icon6-x' },
    children: [
      {
        path: 'detail',
        name: 'member-permisson',
        component: () => import('@/views/member-permisson/index'),
        meta: {
          title: '成员与权限', icon: 'icon6', activeMenu: '/member-permisson/detail',
        },
      },
      {
        path: 'modifyInfo',
        name: 'modify-info',
        component: () => import('@/views/member-permisson/modify-info'),
        meta: {
          title: '编辑成员信息与权限', icon: 'iconcebianlanicon-4', activeMenu: '/member-permisson/detail',
        },
        hidden: true,
      },
    ],
  },
  {
    path: '/liquidation-doc',
    component: Layout,
    name: '清算文件(加盟商)',
    hidden: true,
    meta: { icon: 'liq-doc', activeIcon: 'liq-doc-x' },
    children: [
      {
        path: 'index',
        name: 'liquidation-doc',
        component: () => import('@/views/liquidation-doc/index'),
        meta: { title: '清算文件(加盟商)', icon: 'icon9' },
      },
    ],
  },
  {
    path: '/download-center',
    component: Layout,
    name: '下载中心',
    hidden: true,
    meta: { icon: 'icon9', activeIcon: 'icon9-x' },
    children: [
      {
        path: 'index',
        name: 'download-center',
        component: () => import('@/views/download-center/index'),
        meta: { title: '下载中心', icon: 'icon9' },
      },
    ],
  },
  {
    path: '/flow',
    component: Layout,
    name: '交易流水(旧)',
    meta: { icon: 'icon2', activeIcon: 'icon2-x' },
    children: [
      {
        path: 'detail',
        name: 'flow',
        component: () => import('@/views/flow/index'),
        meta: { title: '交易流水(旧)', icon: 'icon2' },
      },
    ],
  },
  {
    path: '/settlement',
    component: Layout,
    name: '结算汇总信息查询',
    meta: { icon: 'icon3', activeIcon: 'icon3-x' },
    children: [
      {
        path: 'detail',
        name: 'settlement',
        component: () => import('@/views/settlementQuery/index'),
        meta: { title: '结算信息(旧)', icon: 'icon3' },
      },
    ],
  },
  {
    path: '/account',
    component: Layout,
    name: '对账管理(旧)',
    meta: { icon: 'icon4', activeIcon: 'icon4-x' },
    children: [
      {
        path: 'detail',
        name: 'account',
        component: () => import('@/views/account/index'),
        meta: { title: '对账管理(旧)', icon: 'icon4' },
      },
    ],
  },
];

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: { pageTitle: '乐刷收银通商户登录' },
  },
  {
    path: '/forgetPwd',
    component: () => import('@/views/forgetPwd/index'),
    hidden: true,
  },
  {
    path: '/modifyPwd',
    component: () => import('@/views/modifyPwd/index'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    redirect: '/flow-new',
  },
];

export const menuRouteArr = [
  ...menuRoute,
  // // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true },
];

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});

const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;
